const en = {
  title: 'Devices',
  subtitle: 'Devices tracked by serial number, with full repair history',
  addDevice: '+ Add Device',
  lookupTitle: 'Look up a serial number (has this device been serviced before?)',
  serialPlaceholder: 'Enter serial number',
  searching: 'Searching...',
  noDeviceFound: 'No device found for this serial number',
  foundPrefix: 'Found:',
  foundSuffix: '(SN: {{serial}}) — click to view repair history',
  errorLoading: 'Error loading devices: {{error}}',
  noDevicesTitle: 'No Devices Yet',
  noDevicesMessage: 'Devices are usually created automatically when a repair ticket is opened',
  serialNumber: 'Serial Number',
  brand: 'Brand',
  model: 'Model',
  repairs: 'Repairs',
  editDevice: 'Edit Device',
  createDevice: 'Create New Device',
  saveChanges: 'Save Changes',
  deleteDevice: 'Delete Device',
  confirmDelete: 'Are you sure you want to delete "{{name}}"?',
};

const de = {
  title: 'Geräte',
  subtitle: 'Geräte, nachverfolgt anhand der Seriennummer, mit vollständiger Reparaturhistorie',
  addDevice: '+ Gerät hinzufügen',
  lookupTitle: 'Seriennummer nachschlagen (wurde dieses Gerät bereits gewartet?)',
  serialPlaceholder: 'Seriennummer eingeben',
  searching: 'Suche läuft...',
  noDeviceFound: 'Kein Gerät mit dieser Seriennummer gefunden',
  foundPrefix: 'Gefunden:',
  foundSuffix: '(SN: {{serial}}) — klicken, um die Reparaturhistorie anzuzeigen',
  errorLoading: 'Fehler beim Laden der Geräte: {{error}}',
  noDevicesTitle: 'Noch keine Geräte',
  noDevicesMessage: 'Geräte werden in der Regel automatisch erstellt, wenn ein Reparaturauftrag eröffnet wird',
  serialNumber: 'Seriennummer',
  brand: 'Marke',
  model: 'Modell',
  repairs: 'Reparaturen',
  editDevice: 'Gerät bearbeiten',
  createDevice: 'Neues Gerät erstellen',
  saveChanges: 'Änderungen speichern',
  deleteDevice: 'Gerät löschen',
  confirmDelete: 'Möchten Sie „{{name}}" wirklich löschen?',
};

const devices = { en, de };
export default devices;
